export default __webpack_public_path__ + "static/media/jruby.318c6288.svg";